<template>
  <div class="page-content">
    <div class="headings">
      <h2 class="title title-primary">{{ location }}</h2>
      <span>|</span>
      <h2 class="title title-primary">
        {{ $t("lang.inbound.provider.page_title_line_1") }}
      </h2>
      <span>|</span>
      <h3 class="title title-primary">
        {{ $t("lang.inbound.provider.page_title_line_2") }}
      </h3>
    </div>
    <div class="page-header">
      <div class="boxes" v-if="!shouldLoading">
        <bx-box
          dark
          color="outline"
          :title="$t('lang.inbound.provider.box_title_1')"
          no-padding
          class="col-12 col-md-6 col-lg-auto p-1 bx-box-adjustable"
        >
          <div class="detail-titles with-logo">
            <div class="provider-logo">
              <img
                style="height: 70px"
                :src="require('@/assets/i/demoLogo.png')"
              />
            </div>
            <div class="wrapper">
              <h5>
                <strong>{{ provider.name }}</strong>
              </h5>
            </div>
          </div>
        </bx-box>

        <bx-box dark color="outline" class="col-12 col-md-6 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.inbound.provider.box_label_2')"
            :value="stats.average_reception_time"
            font-size="xs"
          />
        </bx-box>

        <bx-box dark color="outline" class="col-6 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.inbound.provider.box_label_3')"
            :value="stats.order_count"
            font-size="xs"
          />
        </bx-box>
        <bx-box dark color="outline" class="col-6 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.inbound.provider.box_label_4')"
            :value="stats.delay_percent"
            units="%"
            font-size="xs"
          />
        </bx-box>
      </div>
      <skeleton-boxes :boxes="3" v-else />
    </div>

    <div class="page-main-content">
      <div class="container-fluid">
        <div class="row" style="margin: 8px">
          <bx-btn @click="$router.back()">{{
            $t("lang.messages.go_back")
          }}</bx-btn>
        </div>
        <v-row class="d-flex d-sm-none">
          <v-list width="100%">
            <v-list-item
              two-line
              v-for="(item, index) in dataPending"
              :key="index"
              class="green lighten-5 ma-2 rounded-lg"
              ripple
              :to="`/inbound/order/${item.order_id}/detail`"
            >
              <v-list-item-content>
                <v-list-item-title>
                  <div>
                    {{ item.order_id }}
                  </div>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-list-item-subtitle class="text-caption">
                  {{ item.itemCount }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption">
                  {{ formatDate(item.receptionTime) }}
                </v-list-item-subtitle>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-row>
        <div class="row mb-5">
          <div class="col-12">
            <bx-box
              :title="
                dataPending.length +
                  ' ' +
                  $t('lang.inbound.provider.table_title_1')
              "
              color="white"
              :loading="shouldLoading"
              no-padding
            >
              <bx-table
                :data="dataPending"
                :columns="columns"
                top-color="red"
                paginated
                backendPagination
                v-if="!shouldLoading"
                :currentPage="pagePendingOrder"
                :perPage="itemsPerPage"
                @update:currentPage="updatePendingOrder"
                :total="totalPendingOrders"
              >
                <template slot-scope="props">
                  <bx-table-column field="waitingTime">{{
                    props.row.waitingTime
                  }}</bx-table-column>
                  <bx-table-column>
                    <router-link
                      :to="`/inbound/order/${props.row.order_id}/detail`"
                      class="bx-link bx-link-bold"
                      >{{ props.row.order_id }}</router-link
                    >
                  </bx-table-column>
                  <bx-table-column field="receptionTime">{{
                    formatDate(props.row.receptionTime)
                  }}</bx-table-column>
                  <bx-table-column>{{ props.row.itemCount }}</bx-table-column>
                </template>
              </bx-table>
            </bx-box>
          </div>
          <div class="col-12">
            <bx-box
              :title="
                dataResolved.length +
                  ' ' +
                  $t('lang.inbound.provider.table_title_2')
              "
              color="white"
              no-padding
            >
              <bx-table
                :data="dataResolved"
                :columns="columns"
                paginated
                backendPagination
                :currentPage="pageResolvedOrder"
                :perPage="itemsPerPage"
                @update:currentPage="updateResolvePage"
                :total="totalResolvedOrders"
              >
                <template slot-scope="props">
                  <bx-table-column field="waitingTime">{{
                    props.row.waitingTime
                  }}</bx-table-column>
                  <bx-table-column>
                    <router-link
                      :to="`/inbound/order/${props.row.order_id}/detail`"
                      class="bx-link bx-link-bold"
                      >{{ props.row.order_id }}</router-link
                    >
                  </bx-table-column>
                  <bx-table-column field="receptionTime">{{
                    formatDate(props.row.receptionTime)
                  }}</bx-table-column>
                  <bx-table-column>{{ props.row.itemCount }}</bx-table-column>
                </template>
              </bx-table>
            </bx-box>
          </div>
          <div class="col-12 d-flex d-sm-none">
            <div
              v-infinite-scroll="loadMore"
              infinite-scroll-disabled="busy"
              infinite-scroll-distance="20"
              style="width: 100%"
            >
              <v-list width="100%">
                <v-list-item
                  two-line
                  v-for="(item, index) in dataList"
                  :key="index"
                  class="green lighten-5 ma-2 rounded-lg"
                  ripple
                  :to="`/inbound/order/${item.order_id}/detail`"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <div>
                        {{ item.order_id }}
                      </div>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-list-item-subtitle class="text-caption">
                      {{ item.itemCount }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="text-caption">
                      {{ formatDate(item.receptionTime) }}
                    </v-list-item-subtitle>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </div>
          </div>
        </div>
        <skeleton-table :columns="4" v-if="shouldLoading" />
      </div>
    </div>
  </div>
</template>
<script>
import BxBtn from "../bx-components/BxBtn";
import common from "@/utils/common";
import moment from "moment";

export default {
  name: "inventoryDashboard",
  components: { BxBtn },
  mixins: [common],
  props: {
    id: {
      type: [Number, String]
    }
  },
  data() {
    return {
      shouldLoading: true,
      columns: [],
      dataList: [],
      dataPending: [],
      dataResolved: [],
      provider: {
        name: ""
      },
      stats: {},
      reloadInterval: null,
      itemsPerPage: process.env.VUE_APP_ITEMS_PER_PAGE,
      pagePendingOrder: 1,
      pageResolvedOrder: 1,
      totalPendingOrders: 0,
      totalResolvedOrders: 0
    };
  },
  computed: {
    location() {
      return localStorage.getItem("location");
    }
  },
  methods: {
    loadMore() {
      if (
        !this.shouldLoading &&
        this.dataList.length &&
        this.dataList.length < this.ordersCount &&
        this.isMobile
      ) {
        this.page++;
        this.getOrders(this.locationId);
      }
    },
    formatDate(date) {
      return date
        ? moment(date).format("DD/ MM/ YYYY, h:mm a")
        : this.$t("lang.messages.no_date_available");
    },
    async getData() {
      try {
        if (this.isMobile) {
          this.shouldLoading = true;
        }
        // Provider data
        this.provider = await this.$api.providers.get(this.id);

        // Provider stats
        this.locationId = localStorage.getItem("location_id");
        this.stats = await this.$api.location.getLocationStatistics(
          this.locationId,
          this.id
        );

        // Get orders
        const orders = await this.$api.providers.orders(this.id);

        const mapOrders = item => {
          return {
            waitingTime: item.waiting_time,
            order_id: item.id,
            receptionTime: item.arrival_date,
            itemCount: item.item_count
          };
        };

        // const pendingOrders = orders.filter(item => item.origin_status:)
        let pendingOrders = orders.filter(
          item => item.destination_status === 0
        );
        this.totalPendingOrders = pendingOrders.length;
        pendingOrders = this.paginate(pendingOrders, this.pagePendingOrder);
        this.dataPending = pendingOrders.map(mapOrders);

        let resolvedOrders = orders.filter(
          item => item.destination_status !== 0
        );
        this.totalResolvedOrders = resolvedOrders.length;
        resolvedOrders = this.paginate(resolvedOrders, this.pageResolvedOrder);
        this.dataResolved = resolvedOrders.map(mapOrders);
        if (this.isMobile) {
          this.dataList = this.dataList.concat(this.dataResolved);
        }

        this.columns = [
          {
            field: "waitinTime",
            label: this.$t("lang.inbound.provider.table_field_1")
          },
          {
            field: "order_id",
            label: this.$t("lang.inbound.provider.table_field_2")
          },
          {
            field: "receptionTime",
            label: this.$t("lang.inbound.provider.table_field_3")
          },
          {
            field: "itemCount",
            label: this.$t("lang.inbound.provider.table_field_4")
          }
        ];
      } catch (error) {
        console.log(error);
      } finally {
        this.shouldLoading = false;
      }
      // { waitingTime: '14:01:10', order_id: '003499204134', 'receptionTime': '14:04:00', gtinCount: 32 },
    },
    updateResolvePage(p) {
      this.pageResolvedOrder = p;
      this.getData();
    },
    updatePendingOrder(p) {
      this.pagePendingdOrder = p;
      this.getData();
    },
    paginate(array, pageNumber) {
      // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
      return array.slice(
        (pageNumber - 1) * this.itemsPerPage,
        pageNumber * this.itemsPerPage
      );
    }
  },
  mounted() {
    if (!this.isMobile) {
      this.reloadInterval = setInterval(
        this.getData,
        process.env.VUE_APP_RELOAD_TIME
      );
    }
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.reloadInterval);
  }
};
</script>

<style scoped>
@media screen and (min-width: 768px) {
  .bx-box-adjustable >>> .bx-box-content {
    height: 108px !important;
  }

  .logo >>> img {
    height: 84px;
  }
}
</style>
